"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingModal = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("@suezenv/react-theme-components/assets/css/main.css");

exports.LoadingModal = function (_a) {
  var _b = _a.isDisabled,
      isDisabled = _b === void 0 ? false : _b;
  if (isDisabled === false) return null;
  return react_1.default.createElement("div", {
    className: "d-flex align-items-center bg-loading w-100 h-100 text-center position-absolute"
  }, react_1.default.createElement(react_theme_components_1.SzSpinner, {
    className: "m-auto opacity-4",
    variant: "light"
  }));
};

exports.default = exports.LoadingModal;